import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '@material-ui/styles';
import { useStyles } from '../styles';

import { Typography } from '@material-ui/core';

import Crud from '../crud';
import Quickcrumbs from '../../global/Quickcrumbs';


const Networks = props => {


    const theme = useTheme();
    const styles = useStyles(theme);

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>

                <Quickcrumbs 
                    crumbs={[
                        {
                            name: 'Settings',
                            route: '/settings'
                        },
                        {
                            name: 'Networks',
                            route: '/settings/networks'
                        }
                    ]}
                    history={props.history}
                />

                <div className={styles.taskbar}>

                    <Typography variant="h4">Networks</Typography>

                </div>
                
                <Typography color="textSecondary" variant="caption" className={styles.space}>A categorization of networks looked after by this system.</Typography>

                <Crud
                    heading='Networks'
                    uri='networks'
                    idCol='id_network'
                    displayColumns={[
                        { 
                            name: 'network_name', 
                            type: 'string',
                            editable: true,
                            required: true
                        }
                    ]}
                />

            </div>

        </div>
    )

}

export default Networks
